import { QuotingPortal } from 'lib/hosts/quoting/interface';
import { Undef } from 'types/UtilityTypes';
import captureException from 'utils/captureException';

export const NavisphereCarrierSubmitAction = 'navisphere-carrier-submit-quote';

export class NavisphereCarrier implements QuotingPortal {
  submitAction = NavisphereCarrierSubmitAction;

  canSubmit(tab: Undef<chrome.tabs.Tab>, _html: string): boolean {
    if (!tab?.url) return false;

    try {
      const url = new URL(tab.url);
      const hostname = url.hostname?.toLowerCase() ?? '';
      const pathname = url.pathname?.toLowerCase() ?? '';

      const isNavisphereDetails =
        hostname.includes('navispherecarrier.com') &&
        pathname.includes('/spot-bid-details/');

      return isNavisphereDetails;
    } catch (error: any) {
      captureException(
        'Error checking Navisphere Carrier if quote can be submitted:',
        error
      );
      return false;
    }
  }
}
